/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataSourceItemFromJSON, DataSourceItemToJSON } from './';
export function DataSourceFromJSON(json) {
    return DataSourceFromJSONTyped(json, false);
}
export function DataSourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        rows: json['rows'].map(DataSourceItemFromJSON),
        columns: json['columns'].map(DataSourceItemFromJSON),
        cells: json['cells'],
    };
}
export function DataSourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        rows: value.rows.map(DataSourceItemToJSON),
        columns: value.columns.map(DataSourceItemToJSON),
        cells: value.cells,
    };
}
